var r="4.22.1";export{r as version};
//# sourceMappingURL=package.json.js.map
